import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import QuestionHeader from './QuestionHeader';

export default class Display extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    onComplete: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const { onComplete } = this.props;
    onComplete();
  }

  render() {
    const { text, id } = this.props;
    return (
      <div data-testid='display-question' className="ma3 w-80 center">
        <p className="tc b f5" style={{ overflowWrap: 'break-word' }}>
          <QuestionHeader linkId={id} text={text} />
        </p>
        <div>This question is read-only.</div>
      </div>
    );
  }
}
